import React, { useState, useEffect } from "react";
import "./NewHeroAbout.css";
import img1 from "../../assets/images/img_hhh.jpg";
import img2 from "../../assets/images/image3.jpeg";
import img3 from "../../assets/images/img_storage_tank_steel.jpg";
import img4 from "../../assets/images/meeting_business22.jpg";

const slides = [
  { image: img1, text: "Engineering Excellence" },
  { image: img2, text: "Regulatory Consulting" },
  { image: img3, text: "Statutory Compliance" },
  { image: img4, text: "Driving Business Growth" },
];

export default function NewHeroAbout() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 4000); // Change slide every 4 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero-container">
      <div className="slider">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === currentIndex ? "active" : ""}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="overlay">
              <h2 className={`slide-text ${index === currentIndex ? "fade-in" : "fade-out"}`}>
                {slide.text}
              </h2>
            </div>
          </div>
        ))}

        {/* Navigation Dots */}
        <div className="nav-dots">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === currentIndex ? "active-dot" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
      </div>

      <div className="hero-content">
        <h1 className="fade-in">Discover SARS India Liaison Pvt Ltd</h1>
        <p className="slide-up">Your Trusted Statutory, Regulatory & Engineering Partner</p>
       
      </div>
    </section>
  );
}
